import * as React from 'react';
import * as classNames from 'classnames';

import style from './StructureEditor.less';
import { WTable } from '../table/WTable';
import { lazyInject } from '../../services/inversify';
import { StructureService } from '../../services/structure_service';
import DialogWrapper from '../dialog/dialog_wrapper';
import { StructureEditorForm } from './StructureEditorForm';
import { WFormFieldSelect } from '../../core/forms/WFormFramework';
import { QueryGenService } from '../../core/querygen/QueryGen.service';
import { WSpinner } from '../elements/spinner/WSpinner';
import { WActionButton } from '../elements/WActionButton';


export interface StructureEditorOptsChooserProps extends React.ClassAttributes<any> {
    OPTS: any;
    modul: string;
    setNewRef?: boolean;
    entitySelected: string; // Die eigene Entity -> um diese aus der Liste auszuschließen
    onSetOpts: (OPTS: any, newRef?: boolean) => void;
    onAfterClose: () => void;
}

export interface StructureEditorOptsChooserState {
    structures?: any;
    selectedStructure?: boolean;
    selectedField?: string;
    selectedFieldList: Array<String>;
    structure: any;
    setNewRef: boolean;
    selectedStructureDisabled: boolean;
    modul: string;
    modulesInfo: Array<any>;
    selectedTable?: string;
    feld?: string;
    entitySelected?: string;
    selectedAuswahl: string;
}

export class StructureEditorOptsChooser extends React.Component<StructureEditorOptsChooserProps, StructureEditorOptsChooserState>  {

    constructor(props: any) {
        super(props);
        this.state = {
            structures: undefined,
            selectedStructure: undefined,
            selectedAuswahl: '',
            selectedField: this.props.OPTS && this.props.OPTS.ENTITY ? this.props.OPTS.ENTITY : undefined,
            entitySelected: this.props.OPTS ? this.props.entitySelected : '',
            selectedFieldList: this.props.OPTS && this.props.OPTS.OUTPUT ? this.props.OPTS.OUTPUT : [],
            structure: {},
            setNewRef: this.props.setNewRef,
            selectedStructureDisabled: this.props.setNewRef,
            modul: '',
            modulesInfo: []
        };
        this.onChange = this.onChange.bind(this);
        this.onChangeFieldList = this.onChangeFieldList.bind(this);
        this.onSetOpts = this.onSetOpts.bind(this);
        this.onSetNewRef = this.onSetNewRef.bind(this);
        this.getModulOptions = this.getModulOptions.bind(this);
        this.onModulesInfoLoaded = this.onModulesInfoLoaded.bind(this);
    }

    @lazyInject(StructureService) private structureService: StructureService;
    @lazyInject(QueryGenService) private queryGenService: QueryGenService;


    componentDidMount() {
        this.queryGenService.getModulesInfo(this.onModulesInfoLoaded);
        if (this.props.OPTS) {
            const modul = this.props.OPTS.MODUL ? this.props.OPTS.MODUL : this.props.modul;
            this.getStructure(modul);
        }
    }

    getStructure(modul: any) {
        this.structureService.getStructure(modul, (s: ReadonlyArray<any>) => this.onStructureLoaded(modul, s), true);
    }

    onStructureLoaded(modul: any, structure: any) {
        this.setState({ structure, modul });
        if (this.props.OPTS && this.props.OPTS.ENTITY && !this.state.structures) {
            const structures = structure[this.props.OPTS.ENTITY];
            this.setState({structures});
        }
    }


    onModulesInfoLoaded(modulesInfo: Array<any>) {
        this.setState({ modulesInfo });
    }

    render() {
        if (!this.state.modulesInfo) {
            return <WSpinner />;
        }

        return (
           <div className = {style.sidebysideWIPSsmall}>
               <div className = {style.titel} >
               <WActionButton
                    tooltip='Speichern'
                    label='Speichern'
                    key='formSave'
                    action='formSave'
                    onAction={() => this.onSetOpts()}
               />
               <WActionButton
                   tooltip='Abbrechen'
                   label='Abbrechen'
                   key='formCancel'
                   action='formCancel'
                   onAction={() => this.props.onAfterClose()}
               />
               </div>

                <div className = {style.formcontainer}>
                        <div style = {{margin: '10px'}}>
                            <label>
                                <input type='checkbox' onChange={this.onSetNewRef} defaultChecked={this.state.setNewRef} /> Neuer Katalog
                            </label>
                        <p style = {{margin: '10px'}}>Auswahl Datenstruktur</p>
                       {this.renderModulSelect()}

                       {Object.keys(this.state.structure).length !== 0 && this.state.structure.constructor === Object &&
                       this.renderStructureSelect()}

                   {this.state.selectedField && this.renderFieldSelect()}

                   {this.state.selectedAuswahl && <div>Auswahl Felder (Anzeige)</div> && this.renderFieldListSelect()}
                   </div>
               </div>
           </div>);
    }
    onSetNewRef() {
        const setNewRef = !this.state.setNewRef;
        const selectedStructureDisabled = setNewRef;
        this.setState({ setNewRef, selectedStructureDisabled });
        if (setNewRef) {
            this.setState({ selectedStructure: undefined });
        }
    }
    renderFieldSelect() {
        const label = (<div className={style.label}>Auswahl Feld</div>);
        const feldOptions = this.getFeldOptions();
        let feld = this.state.selectedAuswahl;

        if (this.props.OPTS && feld === '') {
            feldOptions.forEach((feldKey: any) => {
                if (feldKey.value === this.props.OPTS.INPUT) {
                    feld = feldKey.value;
                    this.setState({ selectedAuswahl: feldKey.value });
                }
            });
        }

        return (
        <WFormFieldSelect
            label={label}
            name='type'
            bundle_value='value'
            bundle_text='key'
            options={feldOptions}
            value={feld}
            onValueChange={(key: string, value: string) => this.setState({ selectedAuswahl: value })}
        />
    );

    }

    getFeldOptions(): Array<any> {

        const struct = this.state && this.state.structures ? this.state.structures.ATTS : {};
        const list = Object.keys(struct).map((s: string) => { return { value: struct[s].KEY, key: struct[s].NAME }; });
        list.splice(0, 0, { value: '', key: 'keine Auswahl' });
        return list;
    }
    renderFieldListSelect() {
        const struct = this.state.structures.ATTS;
        return (
                struct && struct.map((s: any, idx: number) =>
                    <div>
                        <input type='checkbox'
                            key={'check_field_' + idx}
                            name={s.KEY}
                            value={s.KEY}
                            checked={this.state.selectedFieldList.indexOf(s.KEY) > -1}
                            onChange={this.onChangeFieldList}
                        />
                        {s.NAME}
                        <br/>
                    </div>
                )
            );
    }

    renderModulSelect() {
        const label_modul = (<div className={style.label}>Modul</div>);
        const modul = this.state.modul;
        const modulOptions = this.getModulOptions();

        return (
            <WFormFieldSelect
                label={label_modul}
                name='type'
                bundle_value='key'
                bundle_text='value'
                options={modulOptions}
                value={modul}
                onValueChange={(key: string, value: string) => { this.setState({modul: value}); this.getStructure(value); }}
            />
        );
    }

    getModulOptions(): Array<any> {
        const list = this.state.modulesInfo.filter((m: any) => m !== null)
            .map((m: any) => { return { key: m.key, value: m.name }; });
        return list;

    }

    renderStructureSelect () {
        const label_tables = (<div className={style.label}>Tabelle</div>);
        const table = this.state.selectedField ? this.state.selectedField : '';
        const tableOptions = this.getTableOptions();

        return (
        <WFormFieldSelect
            label={label_tables}
            name='type'
            bundle_value='key'
            bundle_text='value'
            options={tableOptions}
            value={table}
            onValueChange={(key: string, value: string) => this.onChange(key, value)}
        />
    );
    }

    getTableOptions(): Array<any> {

        const struct = this.state.structure ? this.state.structure : {};
        const list = Object.keys(struct).map((s: string) => { return { key: s, value: struct[s].TITEL }; });
        list.splice(0, 0, { value: '', key: 'keine Auswahl' });
        return list;
    }

    onChange(table: string, value: string) {
        if (this.state.structure[value]) {
            this.setState({selectedStructure: true, structures: this.state.structure[value], setNewRef: false, entitySelected: value,
            selectedField: value});
            return;
        }
        this.setState({ selectedStructure: false, setNewRef: false });

    }

    onChangeFieldList(event: any) {
        const selectedFieldList = this.state.selectedFieldList;
        const name = event.target.name;
        // console.log('FIELD SELECT: ', event.target, event.target.checked);
        if (event.target.checked) {
            if (selectedFieldList.indexOf(name) === -1) {
                selectedFieldList.push(name);
            }
        } else {
            if (selectedFieldList.indexOf(name) > -1) {
                selectedFieldList.splice(selectedFieldList.indexOf(name), 1);
            }
        }
        this.setState({ selectedFieldList });
    }
    onSetOpts() {
        if (this.state.selectedStructure && this.state.selectedAuswahl) {
            const OPTS = this.props.OPTS ? this.props.OPTS : {};
            OPTS.IDENTIFIER = 'tid';
            OPTS.INPUT = this.state.selectedAuswahl;
            OPTS.OUTPUT = this.state.selectedFieldList;
            OPTS.ENTITY = this.state.structures.SRC.id;
            OPTS.MODUL = this.state.modul;
            this.props.onSetOpts(OPTS);
        } else {
            this.props.onSetOpts(undefined, this.state.setNewRef);
        }
    }
}
